import moment from "moment";
import * as commonConstants from "../constants/common";
import * as utils from "./utils";
import l10n from "../l10n/localization";
import { notNullNorUndefined } from "./utils";
import Fraction from 'fraction.js';

export function displayAllUniquePorts(type, cargos) {
    let portsRenderedArray = [];
    let portsArray = {};

    for (let i = 0 ;  i < cargos.length ; i++) {
        let cargo = cargos[i];

        for (let j = 0 ;  j < cargo.cargoPorts.length ; j++) {
            if (cargo.cargoPorts[j].operation === type) {
                try {
                    portsArray[cargo.cargoPorts[j].port.country.name] = cargo.cargoPorts[j].port.country.name
                } catch (e) {}
            }
        }
    }

    for (let key in portsArray) {
        portsRenderedArray.push(portsArray[key]);
    }

    return portsRenderedArray;
}

export function displayCommodities(cargos) {
    let commoditiesRenderedArray = [];
    let commoditiesArray = {};

    for (let i = 0 ;  i < cargos.length ; i++) {
        let cargo = cargos[i];
        if (utils.notNullNorUndefined(cargo.commodity)) {
            if (cargo.commodity.commodityGroup !== undefined) {
                commoditiesArray[cargo.commodity.commodityGroup.name] = cargo.commodity.commodityGroup.name;
            }
        }
    }

    for (let key in commoditiesArray) {
        commoditiesRenderedArray.push(commoditiesArray[key]);
    }

    return commoditiesRenderedArray;
}

export function sumTonnage(cargos) {
    let quantity = 0;

    if (cargos !== undefined) {
        for (let i = 0 ;  i < cargos.length ; i++) {
            quantity += cargos[i].quantity;
        }
    }

    return quantity;
}

function buildCosts(costs) {
    let builtCosts = '';

    if (utils.notNullNorUndefined(costs)) {
        for (let i = 0; i < costs.length; i++) {
            if (costs[i].invoiceNumber !== '' && utils.notNullNorUndefined(costs[i].invoiceNumber)) {
                builtCosts += costs[i].invoiceNumber;

                if (i < costs.length-1) {
                    builtCosts += ', ';
                }
            }
        }
    }

    return builtCosts;
}

export function buildFogTable(fogs) {
    let result = [];

    if (fogs !== undefined) {
        for (let i = 0; i < fogs.length; i++) {
            let fog = fogs[i];


            result[i] = {
                id: fog.id,
                archived: fog.archived,
                creation_date: fog.creationDate,//moment.unix(fog.creationDate).format('DD.MM.YYYY'),
                file_nb: fog.reference,
                client: utils.notNullNorUndefined(fog.client) ? fog.client.name : '',
                vessel: utils.notNullNorUndefined(fog.vessel) ? fog.vessel.name: '',
                cover_type: '',
                underwriter: utils.notNullNorUndefined(fog.underwriter) ? fog.underwriter.name : '',
                commodities: utils.notNullNorUndefined(fog.cargos) ? displayCommodities(fog.cargos) : [],
                year: moment.unix(fog.creationDate).format('Y'),
                load_country: utils.notNullNorUndefined(fog.cargos) ? displayAllUniquePorts(commonConstants.CARGO_OPERATION_LOAD_KEY, fog.cargos) : [],
                discharge_country: utils.notNullNorUndefined(fog.cargos) ? displayAllUniquePorts(commonConstants.CARGO_OPERATION_DISCHARGE_KEY, fog.cargos) : [],
                total_tonnes: sumTonnage(fog.cargos),
                original: fog,
                affiliate_invoices: buildCosts(fog.costs)
            };
        }
    }

    return result;
}

export function fogToForm(fog) {
    let cleanedFog = Object.assign({}, fog);

    if (utils.notNullNorUndefined(cleanedFog.currency) && cleanedFog.currency.id !== undefined) {
        cleanedFog.currency = cleanedFog.currency.id;
    }

    if (utils.notNullNorUndefined(cleanedFog.client) && cleanedFog.client.id !== undefined) {
        cleanedFog.client = cleanedFog.client.id;
    }

    if (utils.notNullNorUndefined(cleanedFog.vessel) && cleanedFog.vessel.id !== undefined) {
        cleanedFog.vessel = cleanedFog.vessel.id;
    }

    if (utils.notNullNorUndefined(cleanedFog.underwriter) && cleanedFog.underwriter.id !== undefined) {
        cleanedFog.underwriter = cleanedFog.underwriter.id;
    }

    return cleanedFog;
}

export function getCoverTypesEnum(key) {
    let resources = [
        {key: 'N/A', translation: 'N/A'},
        {key: 'CC', translation: l10n.coverType.CC},
        {key: 'MARINE_ONLY', translation: l10n.coverType.MARINE_ONLY},
        {key: 'FOG_ONLY', translation: l10n.coverType.FOG_ONLY},
        {key: 'SIXTY_DAYS_STORAGE_AND_OVERLAND', translation: l10n.coverType.SIXTY_DAYS_STORAGE_AND_OVERLAND},
        {key: 'STORAGE_OVER_SIXTY_DAYS', translation: l10n.coverType.STORAGE_OVER_SIXTY_DAYS},
        {key: 'TRANSHIPMENT', translation: l10n.coverType.TRANSHIPMENT},
    ];

    if (utils.notNullNorUndefined(key)) {
        if (key === 'ENUM') {
            let builtEnum = [];
            for (let i = 0; i < resources.length; i++) {
                builtEnum.push(resources[i].key);
            }
            return builtEnum;
        } else if (key === 'ENUM_NAMES') {
            let builtEnum = [];
            for (let i = 0; i < resources.length; i++) {
                builtEnum.push(resources[i].translation);
            }
            return builtEnum;
        } else if (key === 'BUILT') {
            let builtEnum = [];
            for (let i = 0; i < resources.length; i++) {
                builtEnum.push({
                    label: resources[i].translation,
                    value: resources[i].key,
                });
            }
            return builtEnum;
        }
    }
    return resources;
}


/*
* this.props.fog.overageClientRate * utilsFog.calculateFogTotal(this.props.fog) / 100
*
* ! WARNING ! - Mirror of /home/fog/vh_api/src/AccountingBundle/Utils/FogDocumentNormalizer.php
* */
export function calculateCostInvoices(fog, cargoes) {
    fog = Object.assign({}, fog);

    let result = {
        client: {
            fogPremium: Fraction(0),
            overage: Fraction(0),
            additionalCharges: [],
            additionalChargesSumTyped: {},


            fogSettlement: Fraction(0),
            total: Fraction(0),
        },
        underwriter: {
            fogPremium: Fraction(0),
            overage: Fraction(0),
            brokerageReturn: Fraction(0),
            fogSettlement: Fraction(0),
            total: Fraction(0),
        }
    };


    for (let i = 0; i < fog.cargos.length; i++) {
        if (notNullNorUndefined(fog.cargos[i].clientRate)) {
            let cargoValueWithRate = Fraction(fog.cargos[i].clientRate.rate).mul(fog.cargos[i].value).div(100);
            result.client.fogPremium = result.client.fogPremium.add(roundNumber(cargoValueWithRate.valueOf(), 3));
        }
        if (notNullNorUndefined(fog.cargos[i].underwriterRate)) {
            let cargoValueWithRate = Fraction(fog.cargos[i].underwriterRate.rate).mul(fog.cargos[i].value).div(100);
            result.underwriter.fogPremium = result.underwriter.fogPremium.add(roundNumber(cargoValueWithRate.valueOf(), 3));
        }

        if (fog.overage && !isNaN(fog.overageClientRate) && notNullNorUndefined(fog.overageClientRate)) {
            let frac = Fraction(fog.cargos[i].value).mul(fog.overageClientRate).div(100);
            result.client.overage = result.client.overage.add(roundNumber(frac.valueOf(), 3));
        }

        if (fog.overage && !isNaN(fog.overageUnderwriterRate) && notNullNorUndefined(fog.overageUnderwriterRate)) {
            let frac = Fraction(fog.cargos[i].value).mul(fog.overageUnderwriterRate).div(100);
            result.underwriter.overage = result.underwriter.overage.add(roundNumber(frac.valueOf(), 3));
        }

        if (notNullNorUndefined(fog.cargos[i].clientRate)) {
            if (!isNaN(fog.cargos[i].outturnTonnes) && notNullNorUndefined(fog.cargos[i].outturnTonnes) && !fog.cargos[i].clientRate.isMarineOnly && !fog.cargos[i].excessExclusion) {
                let realQuantity = Fraction(fog.cargos[i].quantity).sub(fog.cargos[i].outturnTonnes);
                let realQuantityPercent = realQuantity.div(fog.cargos[i].quantity);
                let franchise = Fraction(fog.cargos[i].clientRate.franchise).div(100);
                let realCoefficient = realQuantityPercent.sub(franchise);
                let value = Fraction(roundNumber(fog.cargos[i].perTonUsd, 3)).mul(realCoefficient).mul(fog.cargos[i].quantity);

                if (franchise.compare(0) > 0) {
                    if (value.compare(0) > 0) {
                        result.client.fogSettlement = result.client.fogSettlement.add(utils.getFlooredFixed(value.valueOf()));
                        result.underwriter.fogSettlement = result.underwriter.fogSettlement.add(utils.getFlooredFixed(value.valueOf()));
                    }
                } else {
                    result.client.fogSettlement = result.client.fogSettlement.add(utils.getFlooredFixed(value.valueOf()));
                    result.underwriter.fogSettlement = result.underwriter.fogSettlement.add(utils.getFlooredFixed(value.valueOf()));
                }
            }
        }
    }

    if (fog.brokerageReturn) {
        if (!isNaN(fog.rebateRate) && notNullNorUndefined(fog.rebateRate)) {
            result.underwriter.brokerageReturn = Fraction(result.underwriter.fogPremium).add(result.underwriter.overage).mul(fog.rebateRate).div(100);
        } else if (notNullNorUndefined(fog.underwriter)) {
            if (!isNaN(fog.underwriter.rebateRate) && notNullNorUndefined(fog.underwriter.rebateRate)) {
                result.underwriter.brokerageReturn = Fraction(result.underwriter.fogPremium).add(result.underwriter.overage).mul(fog.underwriter.rebateRate).div(100);
            }
        }
    } else {
        result.underwriter.brokerageReturn = Fraction(0);
    }

    if (notNullNorUndefined(fog.invoices)) {
        result.client.additionalCharges = fog.invoices;
    }

    result.client.additionalChargesSumTyped = {
        'INVOICE_CLIENT': Fraction(0),
        'CREDIT_NOTE_CLIENT': Fraction(0),
        'CREDIT_NOTE_UNDERWRITER': Fraction(0),
        'INVOICE_REBATE_UNDERWRITER': Fraction(0),
        'INVOICE_UNDERWRITER': Fraction(0),
    };

    for (let j = 0; j < result.client.additionalCharges.length; j++) {
        let type = result.client.additionalCharges[j].documentType;

        result.client.additionalChargesSumTyped[type] = Fraction(result.client.additionalChargesSumTyped[type]).add(result.client.additionalCharges[j].amount);
    }

    result.client.total = Fraction(result.client.fogPremium).add(result.client.overage).add(result.client.additionalChargesSumTyped['INVOICE_CLIENT']);
    result.underwriter.total = Fraction(result.underwriter.fogPremium).add(result.underwriter.overage).add(result.client.additionalChargesSumTyped['CREDIT_NOTE_UNDERWRITER']);

    let additionalChargesSumTyped = {};
    for (let obj in result.client.additionalChargesSumTyped) {
        additionalChargesSumTyped[obj] = utils.getFlooredFixed(result.client.additionalChargesSumTyped[obj].valueOf())
    }
    
    let returnableResult = {
        additionalChargesSumTyped: additionalChargesSumTyped,
        additionalCharges: result.client.additionalCharges,
        client: {
            fogPremium: result.client.fogPremium.valueOf(),
            overage: utils.getFlooredFixed(result.client.overage.valueOf()),
            fogSettlement: utils.getFlooredFixed(result.client.fogSettlement.valueOf()),
            total: result.client.total.valueOf(),
        },
        underwriter: {
            fogPremium: (result.underwriter.fogPremium.valueOf()),
            overage: utils.getFlooredFixed(result.underwriter.overage.valueOf()),
            brokerageReturn: utils.getFlooredFixed(result.underwriter.brokerageReturn.valueOf()),
            fogSettlement: utils.getFlooredFixed(result.underwriter.fogSettlement.valueOf()),
            total: (result.underwriter.total.valueOf()),
        }
    };

    return returnableResult;
}

function roundNumber(num, scale = 3) {
    if(!("" + num).includes("e")) {
        return +(Math.round(num + "e+" + scale)  + "e-" + scale);
    } else {
        var arr = ("" + num).split("e");
        var sig = ""
        if(+arr[1] + scale > 0) {
            sig = "+";
        }
        return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
}


// WEBPACK FOOTER //
// ./src/utils/fog.js